/**
 * Words whose accented spelling is the right one (SC-3), keyed by the unaccented spelling the en_US
 * list also accepts. "café" passes and "cafe" is flagged, with "café" suggested. Add a pair here
 * to flag another one; a custom or student-list entry still overrides it.
 */
export const ACCENTED_SPELLINGS: ReadonlyMap<string, string> = new Map([
  ['cafe', 'café'],
  ['naive', 'naïve'],
  ['resume', 'résumé'],
])
